import { action, observable } from 'mobx';
import {FilterParams} from 'core/models/index';

class SportStructureFilterParams extends FilterParams {
    @observable accessor sportIds = [];
    @observable accessor sportCategoryIds = [];
    @observable accessor tournamentIds = [];

    constructor() {
        super();

        this.reset();
    }

    @action
    reset() {
        super.reset();

        this.sportIds = [];
        this.sportCategoryIds = [];
        this.tournamentIds = [];
    }
}

export default SportStructureFilterParams;
